import './members.css';

import * as React from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import Group from 'src/entities/Group';
import Member from 'src/entities/Member';

import { updateGroup } from '../../actions/group';
import LoupeGreenLight from '../../res/img/loupe_green_light.svg';
import Profile from '../../res/img/member.svg';
import Navigation from '../Navigation/global';
import SwitchAdmin from '../Navigation/switchAdmin';

interface IProps {
  account: Member;
  group: Group;
  members: Member[];
  updateGroup: (group: Group) => void;
}

interface IState {
  keywordCandidate: string;
  keywordWatcher: string;
  keywordMember: string;
  keywordAdmin: string;
}

class MembersComponent extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      keywordCandidate: '',
      keywordWatcher: '',
      keywordMember: '',
      keywordAdmin: ''
    };
  }

  render() {
    if (this.props.group === undefined) {
      return null;
    }

    if (
      !this.props.account.isSystemAdmin &&
      !this.props.group.admins.includes(this.props.account.id)
    ) {
      return (
        <Redirect
          to={{
            pathname: '/' + this.props.group.title + '/memos'
          }}
        />
      );
    }

    return (
      <div id="SettingsMembers">
        <Navigation group={this.props.group.title} />

        <div id="SwitchAdminContainer">
          <SwitchAdmin isAdmin={true} group={this.props.group} />
        </div>

        <div id="Tabs">
          <div className="Tab TabSelected">メンバー管理</div>
          <Link to={'/' + this.props.group.title + '/settings/functions'}>
            <div className="Tab">ファンクション</div>
          </Link>
          <Link to={'/' + this.props.group.title + '/settings/statistics'}>
            <div className="Tab">統計情報</div>
          </Link>
        </div>
        <div id="Content">
          <div id="Candidates">
            <label>メンバーの候補</label>
            <div className="Search">
              <img src={LoupeGreenLight} />
              <input
                className="InputText"
                value={this.state.keywordCandidate}
                onChange={this.onChangeKeyword.bind(this, 'candidate')}
              />
            </div>
            <div className="Members">
              {this.props.members
                .filter(
                  member =>
                    !member.archived &&
                    !this.props.group.watchers.includes(member.id) &&
                    !this.props.group.members.includes(member.id)
                )
                .filter(
                  member =>
                    member.nameLast.includes(this.state.keywordCandidate) ||
                    member.nameFirst.includes(this.state.keywordCandidate)
                )
                .map(member => (
                  <div className="MemberContainer" key={member.id}>
                    <div className="Member">
                      <img
                        src={member.profile !== null ? member.profile : Profile}
                      />
                      <span>
                        {member.nameLast}
                        {member.nameFirst}
                      </span>
                    </div>
                    <div className="Actions">
                      <div
                        className="Right"
                        onMouseUp={this.moveUpToWatcher.bind(this, member.id)}
                      />
                    </div>
                  </div>
                ))}
            </div>
          </div>
          <div id="Watchers">
            <label>閲覧メンバー</label>
            <div className="Search">
              <img src={LoupeGreenLight} />
              <input
                className="InputText"
                value={this.state.keywordWatcher}
                onChange={this.onChangeKeyword.bind(this, 'watcher')}
              />
            </div>
            <div className="Members">
              {this.props.members
                .filter(member => this.props.group.watchers.includes(member.id))
                .filter(
                  member =>
                    member.nameLast.includes(this.state.keywordWatcher) ||
                    member.nameFirst.includes(this.state.keywordWatcher)
                )

                .map(member => (
                  <div className="MemberContainer" key={member.id}>
                    <div className="Member">
                      <img
                        src={member.profile !== null ? member.profile : Profile}
                      />
                      <span>
                        {member.nameLast}
                        {member.nameFirst}
                      </span>
                    </div>
                    <div className="Actions">
                      <div
                        className="Left"
                        onMouseUp={this.moveDownToCandidate.bind(
                          this,
                          member.id
                        )}
                      />
                      <div
                        className="Right"
                        onMouseUp={this.moveUpToMember.bind(this, member.id)}
                      />
                    </div>
                  </div>
                ))}
            </div>
          </div>

          <div id="Members">
            <label>一般メンバー</label>
            <div className="Search">
              <img src={LoupeGreenLight} />
              <input
                className="InputText"
                value={this.state.keywordMember}
                onChange={this.onChangeKeyword.bind(this, 'member')}
              />
            </div>
            <div className="Members">
              {this.props.members
                .filter(
                  member =>
                    this.props.group.members.includes(member.id) &&
                    !this.props.group.admins.includes(member.id)
                )
                .filter(
                  member =>
                    member.nameLast.includes(this.state.keywordMember) ||
                    member.nameFirst.includes(this.state.keywordMember)
                )

                .map(member => (
                  <div className="MemberContainer" key={member.id}>
                    <div className="Member">
                      <img
                        src={member.profile !== null ? member.profile : Profile}
                      />
                      <span>
                        {member.nameLast}
                        {member.nameFirst}
                      </span>
                    </div>
                    <div className="Actions">
                      <div
                        className="Left"
                        onMouseUp={this.moveDownToWatcher.bind(this, member.id)}
                      />
                      <div
                        className="Right"
                        onMouseUp={this.moveUpToAdmin.bind(this, member.id)}
                      />
                    </div>
                  </div>
                ))}
            </div>
          </div>
          <div id="Admins">
            <label>管理メンバー</label>
            <div className="Search">
              <img src={LoupeGreenLight} />
              <input
                className="InputText"
                value={this.state.keywordAdmin}
                onChange={this.onChangeKeyword.bind(this, 'admin')}
              />
            </div>
            <div className="Members">
              {this.props.members
                .filter(member => this.props.group.admins.includes(member.id))
                .filter(
                  member =>
                    member.nameLast.includes(this.state.keywordAdmin) ||
                    member.nameFirst.includes(this.state.keywordAdmin)
                )
                .map(member => (
                  <div className="MemberContainer" key={member.id}>
                    <div className="Member">
                      <img
                        src={member.profile !== null ? member.profile : Profile}
                      />
                      <span>
                        {member.nameLast}
                        {member.nameFirst}
                      </span>
                    </div>
                    <div className="Actions">
                      <div
                        className="Left"
                        onMouseUp={this.moveDownToMember.bind(this, member.id)}
                      />
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    );
  }

  onChangeKeyword(type: string, e: any) {
    if (type === 'candidate') {
      this.setState({
        keywordCandidate: e.target.value
      });
    }
    if (type === 'watcher') {
      this.setState({
        keywordWatcher: e.target.value
      });
    }
    if (type === 'member') {
      this.setState({
        keywordMember: e.target.value
      });
    }
    if (type === 'admin') {
      this.setState({
        keywordAdmin: e.target.value
      });
    }
  }

  moveUpToWatcher(memberId: number) {
    const group = Object.assign({}, this.props.group);
    group.watchers.push(memberId);
    this.props.updateGroup(group);
  }

  moveUpToMember(memberId: number) {
    const group = Object.assign({}, this.props.group);
    group.watchers = group.watchers.filter(member => member !== memberId);
    group.members.push(memberId);
    this.props.updateGroup(group);
  }

  moveUpToAdmin(memberId: number) {
    const group = Object.assign({}, this.props.group);
    group.admins.push(memberId);
    this.props.updateGroup(group);
  }

  moveDownToMember(memberId: number) {
    if (
      memberId !== this.props.account.id ||
      confirm(
        '自分自身の権限を外すと直ちに本グループについての管理者としての操作ができなくなります。本当によろしいですね？'
      )
    ) {
      const group = Object.assign({}, this.props.group);
      group.admins = group.admins.filter(member => member !== memberId);
      this.props.updateGroup(group);
    }
  }

  moveDownToWatcher(memberId: number) {
    if (
      memberId !== this.props.account.id ||
      confirm(
        '自分自身の権限を外すと直ちに本グループについての一般メンバーとしての操作ができなくなります。本当によろしいですね？'
      )
    ) {
      const group = Object.assign({}, this.props.group);
      group.members = group.members.filter(member => member !== memberId);
      group.watchers.push(memberId);
      this.props.updateGroup(group);
    }
  }

  moveDownToCandidate(memberId: number) {
    const group = Object.assign({}, this.props.group);
    group.watchers = group.watchers.filter(member => member !== memberId);
    this.props.updateGroup(group);
  }
}

const mapStateToProps = (state: any, ownProps: any) => ({
  account: state.Account,
  group: state.Group.find(
    (group: Group) => group.title === ownProps.match.params.group
  ),
  members: state.Member
});

const mapDispatchToProps = (dispatch: any) => {
  return {
    updateGroup(group: Group) {
      dispatch(updateGroup(group));
    }
  };
};

const Members = connect(
  mapStateToProps,
  mapDispatchToProps
)(MembersComponent);

export default Members;



// WEBPACK FOOTER //
// ./src/components/Settings/members.tsx